export default __webpack_public_path__ + "static/media/eth.59b6c08d.svg";